
<div :class="$style.wrapper" right>
    <div :class="$style.root" mini>
        <div :class="$style.header">
            <div>
                {{ title }}
            </div>
            <div :class="$style.status" :status="status">
                {{ status }}
            </div>
        </div>
        <div v-if="completeInfo && completeInfo.length" :class="$style.body">
            <div v-for="info in completeInfo" :class="$style.info">
                <div :class="$style.infoHeader">
                    <div>
                        {{ getPersonalTitle(node.type, info) }}
                    </div>
                    <div :class="$style.infoStatus" :completed="info.completed">
                        {{ getStatusTitle(node.type, info) }}
                    </div>
                </div>
                <div :class="$style.infoBody">
                    {{ getTimeTitle(node.type, info) }}
                </div>
                <div :class="$style.infoBody" v-if="node.current && !info.assignee">
                    处理候选人：{{ getCandidatesTitle(info.candidates) }}
                </div>
            </div>
        </div>
    </div>
</div>
